import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Modules from "./modules";
import "./modules/style/theme.css";

function App() {
  return (
    <div className="App">
      <Modules />
    </div>
  );
}

export default App;
